import {
  Box,
  Divider,
  Step,
  StepIcon,
  StepLabel,
  Stepper,
  Theme,
  useMediaQuery
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import SectionWrapper from "../SectionWrapper/SectionWrapper";
import clsx from "clsx";
import { Clear } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import {mainPageIDs} from "../../qaIDs.json"

const useStyles = makeStyles(theme => ({
  step: {
    padding: theme.spacing(0, 3)
  },
  stepperWrapper: {
    margin: theme.spacing(0, -0.75),
    [theme.breakpoints.down("md")]: {
      margin: 0
    },
    "& .MuiStepConnector-root.Mui-completed span, .MuiStepConnector-root.Mui-active span":
      {
        borderColor: theme.palette.primary.main
      }
  },
  failed: {
    "& .MuiStepConnector-root:nth-child(4) span": {
      borderColor: theme.palette.text.primary + "!important"
    },
    "& .MuiStep-root:last-child .MuiSvgIcon-root": {
      color: theme.palette.text.primary
    }
  }
}));

export default function Steps({ data }: { data: any }) {
  const [activeStep, setActiveStep] = useState(0);
  const screenSm: boolean = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down("md")
  );

  const { route_status, stop_status, stop_type } = data;

  useEffect(() => {
    setActiveStep(
      ["finished", "skipped"].includes(stop_status)
        ? 2
        : route_status === "in_progress"
        ? 1
        : 0
    );
  }, [data]);

  const classes = useStyles();

  const { t } = useTranslation();

  const steps = [
    t("Planned"),
    stop_type === "pickup" ? t("Out for pickup") : t("Out for delivery"),
    stop_type === "pickup" ? t("Picked up") : t("Delivered")
  ];

  return (
    <SectionWrapper>
      <Box py={2.25}>
        <div
          className={clsx(classes.stepperWrapper, {
            [classes.failed]: stop_status === "skipped"
          })}
        >
          <Stepper
            activeStep={activeStep}
            orientation={screenSm ? "vertical" : "horizontal"}
          >
            {steps.map((label, index) => {
              return (
                <Step key={label} className={clsx(classes.step)} id={ (index === 0) ? (mainPageIDs.statusStepPlanned) : ( (index === 1) ? (mainPageIDs.statusStepOnTheWay) : (mainPageIDs.statusStepDelivered))}>
                  <StepLabel
                    StepIconComponent={() => (
                      <StepIcon
                        completed={false}
                        active={activeStep >= index}
                        icon={
                          stop_status === "skipped" &&
                          [t("Delivered"), t("Picked up")].includes(label) ? (
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                borderRadius: 18,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: "text.primary"
                              }}
                            >
                              <Clear style={{ color: "#fff" }} />
                            </Box>
                          ) : (
                            index + 1
                          )
                        }
                      />
                    )}
                  >
                    {stop_status === "skipped" &&
                    [t("Delivered"), t("Picked up")].includes(label)
                      ? t("Failed")
                      : label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </div>
      </Box>
    </SectionWrapper>
  );
}
